import axios from 'axios';
import File from '../../models/File';

const state = function () {
    return {
        selected: [],
        applyToAllResults: false,
        filters: {
            brand: null,
            provider: null,
            category: null,
            query: null
        },
        order: [{
            value: 'id',
            sort: 'desc'
        }],
        items: [],
        limit: 50,
        currentPage: 1,
        page: 1,
        totalItems: 0,
        fetchRoute: null
    };
};

const mutations = {
    SET_ITEMS(state, data) {
        state.items = File.build(data);
    },
    UPDATE_ITEM(state, {
        id,
        data
    }) {
        var index = state.items.findIndex(v => {
            return v.id == id;
        });
        if (index != -1) {
            state.items[index] = state.items[index].update(data);
        }
    },
    REMOVE_ITEM(state, id) {
        var index = state.items.findIndex(v => {
            return v.id == id;
        });
        state.items.splice(index, 1);
    },
    SET_META(state, data) {
        state.totalItems = data.total;
        state.limit = data.per_page;
    },
    SET_FILTERS(state, data) {
        for (var filter in data) {
            state.filters[filter] = data[filter]
        }
    },
    SET_ORDER(state, data) {
        state.order = [data]
    },
    SET_FETCH_ROUTE(state, data) {
        state.fetchRoute = data
    },
    SET_PAGE(state, data) {
        state.page = data
    },
    SET_APPLY_TO_ALL_RESULTS(state, data) {
        state.applyToAllResults = data
    }
};

const actions = {
    resetFilters({
        commit
    }) {
        commit('SET_FILTERS', {
            brand: null,
            provider: null,
            category: null,
            query: null
        })
    },
    setFilters({
        commit
    }, data) {
        commit('SET_FILTERS', data)
        return dispatch('fetch')
    },
    setOrder({
        commit,
        dispatch
    }, data) {
        commit('SET_ORDER', data)
        return dispatch('fetch')
    },
    setPage({
        commit
    }, data) {
        commit('SET_PAGE', data)
        return dispatch('fetch')
    },
    setFetchRoute({
        commit
    }, data) {
        commit('SET_FETCH_ROUTE', data)
    },
    updateInList({
        commit,
        state
    }, {
        id,
        data
    }) {
        commit('UPDATE_ITEM', {
            id,
            data
        })
    },
    removeInList({
        commit
    }, id) {
        commit('REMOVE_ITEM', id)
    },
    fetch({
        commit,
        state
    }, params) {
        let mergedParams = {
            /*
            filters: state.filters,
            order: state.order,
            limit: state.limit,
            page: state.page,
            */
            mode: 'list',
            ...params
        }
        return axios.get('/files', {
            params: mergedParams
        }).then((r) => {
            commit('SET_ITEMS', r.data.data)
            commit('SET_META', r.data.meta)
        })
    },
    setApplyToAllResults({
        commit
    }, data) {
        commit('SET_APPLY_TO_ALL_RESULTS', data)
    }
};

const getters = {
    selected: (state) => state.selected,
    order: (state) => state.order,
    items: (state) => state.items,
    limit: (state) => state.limit,
    currentPage: (state) => state.currentPage,
    totalItems: (state) => state.totalItems,
    filters: (state) => state.filters,
    applyToAllResults: (state) => state.applyToAllResults,
};

let moduleStore = {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};

export default moduleStore;
